module.exports = __webpack_public_path__ + "media/flags/cz-13fa5f4d.svg";